/**
 * @file 动态输入组
 * @author fightingliu
 */

import _ from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Button, Icon } from '@tencent/spaui';
import { hooks } from '@tencent/ptp-fe-common';

import './index.less';

const { useOriginReference, useArray } = hooks;

export default (props) => {
  const {
    value = [],
    onChange,
    inputComponent: InputComponent,
    inputComponentProps = {},
    defaultItemValue,
    addButtonText = '添加',
    addButtonTips = '',
    addButtonPosition = 'top', // 添加按钮的位置
    max, // 最多可以添加的个数
    hideAddBtn = false, // 是否展示添加按钮
    hideDelBtn = false, // 是否展示删除按钮
  } = props;

  const [list, { set, push, updateAt, removeAt }] = useArray(value);
  const [isOperated, setIsOperated] = useState(false);
  const valuePreviousRef = useRef(list);
  const listOriginalCopy = useOriginReference(list);

  // 增加更新条件
  const handleConditionAdd = useCallback(() => {
    push(defaultItemValue);
    setIsOperated(true);
  }, [push, defaultItemValue]);

  useEffect(() => {
    if (!!value && !_.isEqual(valuePreviousRef.current, value)) {
      valuePreviousRef.current = value;
      set(value);
    }
  }, [value, set]);
  useEffect(() => {
    if (!_.isEqual(valuePreviousRef.current, listOriginalCopy)) {
      isOperated && onChange && onChange(listOriginalCopy);
    }
  }, [listOriginalCopy, onChange]);

  return (
    <div className="lead-dynamic-input-group">
      {_.map(list, (listItem, index) => (
        <div className="lead-dynamic-input-item" key={index}>
          <div className="lead-dynamic-input-item-content">
            <InputComponent
              data={listItem}
              idx={index}
              size={_.size(list)}
              onChange={(data) => {
                updateAt(index, data)
                setIsOperated(true);
              }}
              {...inputComponentProps}
            />
          </div>
          {/* 当传入addButtonTips不为空时，需要做特殊处理，删除按钮置灰，只保留提示文案*/}
          {(!hideDelBtn || addButtonTips) && <Button
            disabled = {addButtonTips && hideDelBtn}
            icon={
              <Icon
                name="x-minus"
                className={classNames('icon icon-close2', {
                  disabled: addButtonTips && hideDelBtn,
                })}
              />
            }
            style={{ border: 0, background: 'transparent' }}
            onClick={() => {
              removeAt(index)
              setIsOperated(true);
            }}
          />
          }
        </div>
      ))}
      {addButtonPosition === 'bottom' && (!hideAddBtn || addButtonTips) && ((max && _.size(list) < max) || !max) && <p
        className="lead-dynamic-input-add-button">
        {!hideAddBtn && <div onClick={handleConditionAdd}><Icon type="add"/>{addButtonText}</div>}
        {addButtonTips && <span style={{ color: '#939599' }}>{addButtonTips}</span>}
      </p>}
    </div>
  );
};
